<template>
  <div class="auth-layout">
    <router-view />
  </div>
</template>
